
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("awg6S", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");





var $T1bCI = parcelRequire("T1bCI");


var $8hUXc = parcelRequire("8hUXc");


var $4PPzL = parcelRequire("4PPzL");


var $gqqjz = parcelRequire("gqqjz");


var $1DWH0 = parcelRequire("1DWH0");

/**
 * @generated SignedSource<<1960df6d4d8699143c45b603964b7e5b>>
 * @relayHash 7ba614836c690fbab956e7bd525f36be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1f58d99ee276da4036c48deb1856ec4395acdc64d53a16e90e91c3634e592bf3
const $2534c4c39a9ff8b9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "templateId"
        }
    ], v1 = [
        {
            "alias": "template",
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentTemplateId",
                    "variableName": "templateId"
                }
            ],
            "concreteType": "ContentTemplate",
            "kind": "LinkedField",
            "name": "confluence_template",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "templateId"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "EnrichableMap_ContentRepresentation_ContentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "TemplatePropertySet",
                    "kind": "LinkedField",
                    "name": "templatePropertySet",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "contentAppearance"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "VariableInputDrawerComponentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "VariableInputDrawerComponentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7ba614836c690fbab956e7bd525f36be",
            "id": "1f58d99ee276da4036c48deb1856ec4395acdc64d53a16e90e91c3634e592bf3",
            "metadata": {},
            "name": "VariableInputDrawerComponentQuery",
            "operationKind": "query",
            "text": "query VariableInputDrawerComponentQuery($templateId:String!){template:confluence_template(contentTemplateId:$templateId){templateId,name,body{atlas_doc_format{value}},templatePropertySet{contentAppearance}}}"
        }
    };
}();
$2534c4c39a9ff8b9$var$node.hash = "bafa9cf0cc6b100c33f92219cd24070c";
var $2534c4c39a9ff8b9$export$2e2bcd8739ae039 = $2534c4c39a9ff8b9$var$node;


/**
 * @generated SignedSource<<331db547c854d7d1a982c5b09d088db6>>
 * @relayHash 040a6b2851053e2c9769475ef269bf98
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dc78c1e9d68a31099e920cad6d459b318b00f47fa6ae79a4449170b60ff69d4f
const $3df4ace3eaef0ad2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "variables"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "expand",
            "value": "metadata.simple.isFabric,space,version"
        },
        {
            "fields": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "name",
                                    "variableName": "title"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "spaceKey",
                                    "variableName": "spaceKey"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "variables",
                                    "variableName": "variables"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "context"
                        },
                        {
                            "kind": "Variable",
                            "name": "templateId",
                            "variableName": "templateId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "contentBlueprintSpec"
                },
                {
                    "kind": "Literal",
                    "name": "contentStatus",
                    "value": "DRAFT"
                },
                {
                    "kind": "Literal",
                    "name": "nextVersion",
                    "value": 1
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        },
        {
            "kind": "Variable",
            "name": "pageAri",
            "variableName": "pageAri"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "subType"
            },
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v6 /*: any*/ 
                ]
            },
            {
                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "editui"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentMetadata_SimpleContentMetadataProvider_simple",
                        "kind": "LinkedField",
                        "name": "simple",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFabric"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "VariableInputDrawerComponentUpdateInstanceMutation",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "ConfluenceUpdateInstancePayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateInstance",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "VariableInputDrawerComponentUpdateInstanceMutation",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "ConfluenceUpdateInstancePayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateInstance",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "040a6b2851053e2c9769475ef269bf98",
            "id": "dc78c1e9d68a31099e920cad6d459b318b00f47fa6ae79a4449170b60ff69d4f",
            "metadata": {},
            "name": "VariableInputDrawerComponentUpdateInstanceMutation",
            "operationKind": "mutation",
            "text": "mutation VariableInputDrawerComponentUpdateInstanceMutation($pageAri:ID!,$templateId:String,$title:String,$spaceKey:String,$variables:[ConfluenceTemplateVariableInput]){confluence_updateInstance(pageAri:$pageAri,input:{contentBlueprintSpec:{templateId:$templateId,context:{name:$title,spaceKey:$spaceKey,variables:$variables}},contentStatus:DRAFT,nextVersion:1},expand:\"metadata.simple.isFabric,space,version\"){content{id,type,title,subType,space{key,id},links{editui},metadata{simple{isFabric}}},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$3df4ace3eaef0ad2$var$node.hash = "261540ed3b67aab287eaac9752045356";
var $3df4ace3eaef0ad2$export$2e2bcd8739ae039 = $3df4ace3eaef0ad2$var$node;



var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");





var $j1Ss3 = parcelRequire("j1Ss3");


var $gmMgo = parcelRequire("gmMgo");


var $a2xFu = parcelRequire("a2xFu");


var $hArLp = parcelRequire("hArLp");


var $4KS7f = parcelRequire("4KS7f");


var $dn4ZF = parcelRequire("dn4ZF");


var $lAFHW = parcelRequire("lAFHW");


var $5Lrkh = parcelRequire("5Lrkh");


var $aoVih = parcelRequire("aoVih");


var $aTWRz = parcelRequire("aTWRz");


var $bavCP = parcelRequire("bavCP");


var $cqmCC = parcelRequire("cqmCC");


var $1uFM6 = parcelRequire("1uFM6");


var $fGzMp = parcelRequire("fGzMp");


var $cb6fO = parcelRequire("cb6fO");


var $gXsSh = parcelRequire("gXsSh");


var $aRlro = parcelRequire("aRlro");


var $lJDEI = parcelRequire("lJDEI");


var $1d2ww = parcelRequire("1d2ww");


var $c4PY4 = parcelRequire("c4PY4");


var $1NBp8 = parcelRequire("1NBp8");


var $jqe2L = parcelRequire("jqe2L");


var $6s78L = parcelRequire("6s78L");


var $ge2sX = parcelRequire("ge2sX");


var $fBjVq = parcelRequire("fBjVq");

/* eslint-disable react/no-multi-comp */ 



var $fzqvY = parcelRequire("fzqvY");


var $6mzxy = parcelRequire("6mzxy");

var $kVCDE = parcelRequire("kVCDE");

var $4CUNa = parcelRequire("4CUNa");
/* drawer-sidebar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $bYDHH = parcelRequire("bYDHH");

const $aabe85a93fde0d38$var$styles = {
    default: "_4cvr1h6o _vchhusvi _syazazsu _1e0c1txw _1o9zidpf _2lx21bp4 _4t3i1kxc _n3tdpxbi _ca0q1ejb _1bsbxncg"
}; /**
    * __Drawer sidebar__
    *
    * The sidebar of the drawer panel.
    */ 
const $aabe85a93fde0d38$export$25c48648e7980210 = ({ children: children, xcss: xcss })=>{
    (0, $bYDHH.useEnsureIsInsideDrawer)();
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $aabe85a93fde0d38$var$styles.default,
            xcss
        ]),
        "data-testid": "drawer-sidebar",
        children: children
    });
};


/* TemplateVariableInputStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ // Constants






var $7sObp = parcelRequire("7sObp");

const $a8b6135874d5ee7b$var$getMaxWidth = (isFullWidth)=>isFullWidth ? '1800px' : '760px';
const $a8b6135874d5ee7b$export$7f54a991f8ee6d59 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFullWidth: isFullWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_b02nxi": (0, $7sObp.default)($a8b6135874d5ee7b$var$getMaxWidth(__cmplp.isFullWidth))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f86bv _u5f3xncg _1e0c1txw _vchh1ntv _1bahesu3 _4t3iys9h _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $a8b6135874d5ee7b$export$b3a1ce96385f2e2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "header", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFullWidth: isFullWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_b02nxi": (0, $7sObp.default)($a8b6135874d5ee7b$var$getMaxWidth(__cmplp.isFullWidth))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1ule _vchh1ntv _p12f86bv",
            __cmplp.className
        ])
    });
});
const $a8b6135874d5ee7b$export$5a26c06c0fcefedc = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_7yjtidpf",
            __cmplp.className
        ])
    });
});
const $a8b6135874d5ee7b$export$c07ffdac44786e91 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_8ycoglyw",
            __cmplp.className
        ])
    });
});
const $a8b6135874d5ee7b$export$583f25f3ff99295e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $a8b6135874d5ee7b$export$cc8b65d083f443a0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo1wug _18m91wug _16jlkb7n _u5f3xncg _19bvv77o",
            __cmplp.className
        ])
    });
});
const $a8b6135874d5ee7b$export$da0ac03886d7f9ab = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16qs1pw9",
            __cmplp.className
        ])
    });
});
const $a8b6135874d5ee7b$export$e3cad7a6d45ce703 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _p12f1osq _o5724jg8",
            __cmplp.className
        ])
    });
});
const $a8b6135874d5ee7b$export$e9df20cb66227872 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _p12f1osq _kqswh2mm _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $a8b6135874d5ee7b$export$bdc3c19374266b98 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_vr2wn7od",
            __cmplp.className
        ])
    });
});


const $b83b76c5e91d8f51$var$CustomDrawerContentFormWrapper = (props)=>{
    const { hasForm: hasForm, onSubmit: onSubmit } = props;
    return hasForm && typeof onSubmit === 'function' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", {
            ...formProps,
            name: "text-fields",
            style: {
                height: '100%'
            }
        }, props.children)) : props.children;
};
class $b83b76c5e91d8f51$export$fbbc2ad04fac20ff extends (0, $42omo.PureComponent) {
    componentDidMount() {
        // atlaskit/drawer's body has it's own scroll and the content underneath has scroll
        // so there is a double scroll in fullpage view
        document.body.style.overflow = 'hidden';
    }
    componentDidUpdate() {
        // atlaskit/drawer's body has it's own scroll and the content underneath has scroll
        // so there is a double scroll in fullpage view
        // when it updates it adds the scroll back so gotta remove it again ;_;
        document.body.style.overflow = 'hidden';
    }
    // restore scroll to the main content body
    componentWillUnmount() {
        document.body.style.overflow = '';
    }
    render() {
        const { Content: Content, Footer: Footer, hasForm: hasForm, isOpen: isOpen, Icon: Icon, Body: Body, Title: Title, isLoading: isLoading, isFullWidth: isFullWidth } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6mzxy.Drawer), {
            isOpen: isOpen,
            width: "full"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aabe85a93fde0d38$export$25c48648e7980210), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kVCDE.DrawerCloseButton), {
            icon: Icon
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4CUNa.DrawerContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b83b76c5e91d8f51$var$CustomDrawerContentFormWrapper, {
            hasForm: hasForm,
            onSubmit: this._submit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8b6135874d5ee7b$export$583f25f3ff99295e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8b6135874d5ee7b$export$cc8b65d083f443a0), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Content, {
            ref: this.drawerScrollRef,
            Title: Title,
            Body: Body,
            isFullWidth: isFullWidth
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8b6135874d5ee7b$export$da0ac03886d7f9ab), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Footer, {
            isLoading: isLoading,
            isFullWidth: isFullWidth
        }))))));
    }
    constructor(props){
        super(props);
        this.drawerScrollRef = void 0;
        this._submit = async (data)=>{
            const { onSubmit: onSubmit } = this.props;
            if (onSubmit) await onSubmit(data);
        };
        this.drawerScrollRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
    }
}


const $b91a0339b76d78ea$export$d56aac57734a21f1 = ()=>({
        type: 'sendUIEvent',
        data: {
            source: 'variableInputDrawer',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'submitVariablesCreateTemplateSuccess'
        }
    });
const $b91a0339b76d78ea$export$402481529affdc8f = (error)=>({
        type: 'sendUIEvent',
        data: {
            source: 'variableInputDrawer',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'submitVariablesCreateTemplateError',
            attributes: {
                error: error
            }
        }
    });




var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");

function $e0a8e17ed5e96c3d$export$8142721d7112d638(str) {
    if (str) try {
        return JSON.parse(str);
    } catch  {}
    return null;
}
async function $e0a8e17ed5e96c3d$export$d7a10952ee32f22b(response) {
    if (response) try {
        return await response.json();
    } catch  {}
    return null;
}



var $bZ9Ng = parcelRequire("bZ9Ng");

const $6a854e7d6f4702da$export$2552aac6aac419af = ({ variables: variables })=>{
    const blueprintSpec = (0, $e0a8e17ed5e96c3d$export$8142721d7112d638)(variables.blueprint);
    const contextValue = variables.context && (0, $e0a8e17ed5e96c3d$export$8142721d7112d638)(variables.context);
    const commonContentProperties = {
        type: 'page',
        status: 'draft',
        space: {
            key: variables.spaceKey
        },
        title: variables.title
    };
    if (variables.parentPageId && variables.parentPageId !== 'no-parent-page') commonContentProperties.ancestors = [
        {
            id: variables.parentPageId
        }
    ];
    if (variables.subType) commonContentProperties.subType = variables.subType;
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/api/template/page/${blueprintSpec.templateId}/instance${variables.attemptSpaUrlResponse ? '?expand=metadata.properties.editor,space' : ''}`,
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: JSON.stringify({
            content: {
                ...commonContentProperties
            },
            contentBlueprintSpec: {
                contentTemplateId: blueprintSpec.templateId,
                context: contextValue || {}
            }
        }),
        variables: variables,
        parseResult: async (response)=>{
            const editui = await (0, $bZ9Ng.getEditDraftPageUrl)(response, variables.attemptSpaUrlResponse);
            if (!editui) throw new Error('Missing content draft url');
            return {
                experimentalPublishPageByTemplate: {
                    links: {
                        draftUrl: editui
                    }
                }
            };
        }
    });
};


class $ba011957fd886511$export$7a27bf3882214e56 extends (0, $42omo.PureComponent) {
    /**
   * Converts an object to a list of {key: string, value: any} objects to be consumed by graphql.
   * @param obj
   * @returns An array of key-value pair objects.
   */ _convertObjectToKeyValueList(obj) {
        if (!obj || typeof obj !== 'object') return [];
        return Object.entries(obj).map(([key, value])=>({
                key: key,
                value: value
            }));
    }
    getAdf(adfString) {
        try {
            return JSON.parse(adfString);
        } catch  {
            return {};
        }
    }
    render() {
        const { templateId: templateId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: (0, $2534c4c39a9ff8b9$export$2e2bcd8739ae039),
            variables: {
                templateId: templateId
            },
            fetchPolicy: "network-only",
            errorPolicy: "all"
        }, this._variableInputDrawer));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isLoading: true,
            isCreating: false
        };
        this._onClose = ()=>{
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE),
                reason: 'closed dialog'
            });
            const { onClose: onClose } = this.props;
            onClose();
        };
        /**
     * Called when creating draft with template content.
     * @param context - template context containing variables and page context
     * @return links object with draft link
     * @throws error if the experimentalPublishPageByTemplate resolver throws an error
     */ this._fetchDraftUrl = async (context)=>{
            const { templateId: templateId, parentPageId: parentPageId, spaceKey: spaceKey, title: title, forceTemplatePanelOpen: forceTemplatePanelOpen, match: match } = this.props;
            const blueprint = {
                templateId: templateId
            };
            const isEditorPage = match?.name === (0, $1NBp8.EDIT_PAGE_V2).name || match?.name === (0, $1NBp8.EDIT_BLOG_V2).name;
            const mutationVariables = {
                blueprint: JSON.stringify(blueprint),
                parentPageId: parentPageId || 'no-parent-page',
                context: JSON.stringify(context),
                spaceKey: spaceKey,
                title: title || '',
                attemptSpaUrlResponse: forceTemplatePanelOpen && !isEditorPage,
                forceTemplatePanelOpen: forceTemplatePanelOpen
            };
            // creating new instance from create dialog
            const draftObj = await (0, $6a854e7d6f4702da$export$2552aac6aac419af)({
                variables: mutationVariables
            });
            let draftUrl = draftObj?.data?.experimentalPublishPageByTemplate?.links?.draftUrl;
            if (!draftUrl) throw new Error('draftUrl not defined');
            if (forceTemplatePanelOpen && !isEditorPage) draftUrl = (0, $cb6fO.addQueryParams)(draftUrl, {
                [(0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME)]: (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN),
                [(0, $lJDEI.CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME)]: 'true'
            });
            return {
                draftUrl: draftUrl
            };
        };
        /**
     * Called when updating a draft with existing contentId
     * @param context - template context containing variables and page context
     * @return OnContentUpdatedResponse containing content, links, metadata as a subset of update instance json response
     * @private
     */ this._fetchOnContentUpdatedResponse = async (context)=>{
            const { contentId: contentId, templateId: templateId, spaceKey: spaceKey, title: title } = this.props;
            const blueprint = {
                templateId: templateId
            };
            // updating an existing instance using content id
            const cloudId = (0, $ge2sX.getCloudId)();
            if (!cloudId || !contentId) throw new Error('Cloud ID or content ID not found');
            const draftObj = await (0, $6s78L.mutateInterop)({
                mutation: (0, $3df4ace3eaef0ad2$export$2e2bcd8739ae039),
                variables: {
                    pageAri: (0, $a2xFu.ConfluencePageAri).create({
                        siteId: cloudId ?? '',
                        pageId: contentId ?? ''
                    }).toString(),
                    templateId: blueprint.templateId,
                    spaceKey: spaceKey,
                    title: title || '',
                    variables: this._convertObjectToKeyValueList(context)
                }
            });
            if (draftObj?.data?.confluence_updateInstance?.errors?.[0]) // Error will be handled in _handleSubmitError
            throw new Error(draftObj?.data?.confluence_updateInstance?.errors?.[0]?.message ?? 'Unknown error when updating draft with template: ' + JSON.stringify(draftObj?.data?.confluence_updateInstance?.errors));
            else {
                const onContentUpdatedResponse = draftObj?.data?.confluence_updateInstance;
                return {
                    content: {
                        id: onContentUpdatedResponse?.content?.id ?? '',
                        type: onContentUpdatedResponse?.content?.type ?? '',
                        subType: onContentUpdatedResponse?.content?.subType ?? '',
                        title: onContentUpdatedResponse?.content?.title ?? '',
                        space: {
                            id: onContentUpdatedResponse?.content?.space?.id ?? '',
                            key: onContentUpdatedResponse?.content?.space?.key ?? ''
                        },
                        _links: {
                            editui: onContentUpdatedResponse?.content?.links?.editui ?? ''
                        },
                        metadata: {
                            simple: {
                                isFabric: onContentUpdatedResponse?.content?.metadata?.simple?.isFabric ?? null
                            },
                            properties: null
                        }
                    }
                };
            }
        };
        // https://github.com/final-form/react-final-form/issues/103
        // If users name variables using numbers it breaks the form
        // hacky fix added a $ character in front, this function is here to remove it
        this._sanitizeData = (data)=>{
            const sanitized = {};
            Object.keys(data).forEach((key)=>{
                const cleanedKey = key.substr(1);
                sanitized[cleanedKey] = data[key];
            });
            return sanitized;
        };
        this._onSubmit = async (data)=>{
            const { beforeUpdateRequest: beforeUpdateRequest } = this.props;
            const context = this._sanitizeData(data);
            this.setState({
                isLoading: true,
                isCreating: true
            });
            try {
                if (this.props.contentId) {
                    beforeUpdateRequest && beforeUpdateRequest();
                    const onContentUpdatedResponse = await this._fetchOnContentUpdatedResponse(context);
                    this._handleUpdateSubmitSuccess(onContentUpdatedResponse);
                } else {
                    const draftUrlObj = await this._fetchDraftUrl(context);
                    this._handleCreateSubmitSuccess(draftUrlObj);
                }
                this.setState({
                    isCreating: true
                });
                return true;
            } catch (errors) {
                this._handleSubmitError(errors);
                this.setState({
                    isLoading: false,
                    isCreating: false
                });
                return false;
            }
        };
        this._sendSuccessMetrics = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            createAnalyticsEvent((0, $b91a0339b76d78ea$export$d56aac57734a21f1)()).fire();
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE)
            });
        };
        this._handleCreateSubmitSuccess = (link)=>{
            const { push: push, openContentInNewTab: openContentInNewTab, onClose: onClose } = this.props;
            this._sendSuccessMetrics();
            const draftUrl = `${window.location.origin}${(0, $jqe2L.processDraftUrl)(link.draftUrl)}`;
            if (openContentInNewTab) {
                window.open(draftUrl, '_blank', 'noreferrer');
                onClose();
            } else push(draftUrl, true);
        };
        /**
     * Handle callback (editor refresh, state, etc.) after content is updated
     * @param response - update instance response from experimental graphql call
     * @private
     */ this._handleUpdateSubmitSuccess = (response)=>{
            const { onContentUpdated: onContentUpdated, replace: replace, onClose: onClose } = this.props;
            if (onContentUpdated) {
                onContentUpdated(response);
                onClose();
            } else // if editui is null or undefined, the outside error boundary is hit (creation error)
            replace(`${window.location.origin}${(0, $aTWRz.CONTEXT_PATH)}${response.content._links.editui}`);
            this._sendSuccessMetrics();
        };
        this._handleSubmitError = (error)=>{
            const { flags: flags, intl: intl, createAnalyticsEvent: createAnalyticsEvent, onError: onError } = this.props;
            if (onError) onError(error);
            else flags.showErrorFlag({
                title: intl.formatMessage({
                    id: "editor.template.variable.input.creation.error.title",
                    defaultMessage: "Something went wrong"
                }),
                description: intl.formatMessage({
                    id: "editor.template.variable.input.creation.error.description",
                    defaultMessage: "Refresh the page and try again. If this keeps happening, let us know using the link below."
                }),
                actions: [
                    {
                        content: intl.formatMessage({
                            id: "editor.template.variable.input.creation.error.action",
                            defaultMessage: "Visit Atlassian Support"
                        }),
                        onClick: ()=>{
                            window.open((0, $cqmCC.ATLASSIAN_SUPPORT_URL), '_blank');
                        }
                    }
                ]
            });
            if ((0, $1uFM6.isUnauthorizedError)(error)) this._sendSuccessMetrics();
            else {
                createAnalyticsEvent((0, $b91a0339b76d78ea$export$402481529affdc8f)(`${error}`)).fire();
                (0, $fGzMp.getExperienceTracker)().fail({
                    name: (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE),
                    error: error
                });
            }
        };
        this.Icon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8b6135874d5ee7b$export$c07ffdac44786e91), {
                "data-testid": "variable-input-drawer-button-wrapper"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.ConfluenceIcon), null),
                appearance: "subtle",
                onClick: this._onClose,
                tabIndex: -1
            }));
        this.Footer = (props)=>{
            const { intl: intl } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8b6135874d5ee7b$export$7f54a991f8ee6d59), {
                isFullWidth: props.isFullWidth
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dn4ZF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                type: "submit",
                appearance: "primary",
                isLoading: props.isLoading
            }, intl.formatMessage({
                id: "create.name",
                defaultMessage: "Create"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                appearance: "subtle",
                onClick: this._onClose
            }, intl.formatMessage({
                id: "button.cancel",
                defaultMessage: "Cancel"
            })))));
        };
        this.Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(// @ts-ignore TODO: fix
        (props, ref)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ref: ref
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8b6135874d5ee7b$export$b3a1ce96385f2e2), {
                isFullWidth: props.isFullWidth
            }, props.Title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), null, // eslint-disable-next-line react/no-this-in-sfc
            this.props.intl.formatMessage({
                id: "template.variables.fabric.section.message",
                defaultMessage: "This template uses variables. Once you fill them in, the information you supply will become part of the content in your new page."
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                style: {
                    marginTop: "var(--ds-space-250, 20px)"
                }
            }, props.Body));
        });
        /**
     * When the render loads, it still takes time for content to show
     * so there is a time period where it's just white
     * using onComplete instead of graphql's loading makes the loading state more accurate
     */ this.onComplete = ()=>{
            if (!this.state.isCreating) this.setState({
                isLoading: false
            });
        };
        this._variableInputDrawer = ({ data: data, loading: loading })=>{
            const { templateId: templateId, spaceKey: spaceKey, isOpen: isOpen, title: title } = this.props;
            if (loading) return null;
            const adfString = data?.template?.body?.atlas_doc_format?.value || '{}';
            // title can be passed in if set through create template macro
            // with the following key values that are filled out and replaced by the BE @currentTime @spaceKey @spaceName
            const pageTitle = title || data?.template?.name || '';
            const contentAppearanceProperty = data?.template?.templatePropertySet?.contentAppearance || (0, $aRlro.GraphQLTemplateContentAppearance).DEFAULT;
            const contentAppearance = (0, $aRlro.convertGraphQLTemplateContentAppearanceToContentAppearanceType)(contentAppearanceProperty);
            const contentAppearanceForRenderer = (0, $c4PY4.getContentAppearanceForAtlaskit)(contentAppearance);
            const isFullWidth = contentAppearance === (0, $1d2ww.ContentAppearanceType).FULL_WIDTH;
            const TitleComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8b6135874d5ee7b$export$5a26c06c0fcefedc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Lrkh.default), null, pageTitle));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b83b76c5e91d8f51$export$fbbc2ad04fac20ff), {
                isOpen: isOpen,
                Icon: this.Icon,
                hasForm: true,
                Content: this.Content,
                Title: TitleComponent,
                Body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fBjVq.default), {
                    adf: this.getAdf(adfString),
                    appearance: contentAppearanceForRenderer,
                    objectId: templateId,
                    spaceKey: spaceKey,
                    showTemplateVariablesInPreview: true,
                    showTemplateInputInPreview: true,
                    onComplete: this.onComplete,
                    allowPlaceholderText: true,
                    isPreviewMode: true
                }),
                Footer: this.Footer,
                onSubmit: this._onSubmit,
                isLoading: this.state.isLoading,
                isFullWidth: isFullWidth
            });
        };
    }
}
const $ba011957fd886511$var$injectedComponent = (0, $gmMgo.default)((0, $gXsSh.withRoutesContext)($ba011957fd886511$export$7a27bf3882214e56));
const $ba011957fd886511$export$78f5217efac0587b = (0, $j1Ss3.withApollo)($ba011957fd886511$var$injectedComponent);


const $87832188c5eb10c0$var$VariableInputDrawer = ({ createAnalyticsEvent: createAnalyticsEvent })=>{
    const { contentId: contentId, spaceKey: spaceKey, parentPageId: parentPageId, templateId: templateId, title: title, showTemplateVariableInputDrawer: showTemplateVariableInputDrawer, onClose: onClose, onContentUpdated: onContentUpdated, beforeUpdateRequest: beforeUpdateRequest, onError: onError, forceTemplatePanelOpen: forceTemplatePanelOpen, openContentInNewTab: openContentInNewTab } = (0, $42omo.useContext)((0, $8hUXc.CreateDialogContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: "fabric"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, templateId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ba011957fd886511$export$78f5217efac0587b), {
            isOpen: showTemplateVariableInputDrawer,
            spaceKey: spaceKey,
            parentPageId: parentPageId,
            templateId: templateId,
            title: title,
            onClose: onClose,
            flags: flags,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: contentId,
            onContentUpdated: onContentUpdated,
            beforeUpdateRequest: beforeUpdateRequest,
            forceTemplatePanelOpen: forceTemplatePanelOpen,
            openContentInNewTab: openContentInNewTab,
            onError: onError
        }) : null)));
};
var $87832188c5eb10c0$export$2e2bcd8739ae039 = (0, $1DWH0.default)()($87832188c5eb10c0$var$VariableInputDrawer);



var $ep3mz = parcelRequire("ep3mz");


var $3Qugp = parcelRequire("3Qugp");


var $7zgzO = parcelRequire("7zgzO");


var $3IBnw = parcelRequire("3IBnw");










var $detoO = parcelRequire("detoO");




var $4QflW = parcelRequire("4QflW");

/* eslint-disable check-file/filename-blocklist */ const $df017159f24bbbc7$export$65bf3eec2a811fa = (url, query, spaceKey)=>{
    if (!/.*\/viewpreviousversions\.action/.test(url)) return {
        url: url,
        query: query
    };
    const newQuery = {
        ...query
    };
    delete newQuery.pageId;
    return {
        url: `/wiki/spaces/${spaceKey}/history/${query.pageId}`,
        query: newQuery
    };
};
const $df017159f24bbbc7$export$a91aef22a1a3231b = ({ createDialog: createDialog })=>[
        'true',
        'close'
    ].includes(createDialog);


class $7a89639eeb268429$var$CreateDialogQueryRendererComponent extends (0, $42omo.Component) {
    static getDerivedStateFromProps(props) {
        const { getQueryParams: getQueryParams, showVariableInputDrawer: showVariableInputDrawer } = props;
        const { createDialog: createDialog, createDialogSpaceKey: createDialogSpaceKey, createDialogBlueprintId: createDialogBlueprintId, createDialogTemplateId: createDialogTemplateId, parentPageId: parentPageId } = getQueryParams();
        return {
            isCreateDialogOpen: createDialog === 'true',
            shouldSuppressDialog: !!(createDialogSpaceKey && (createDialogBlueprintId || createDialogTemplateId)),
            parentPageId: parentPageId,
            showVariableInputDrawer: showVariableInputDrawer
        };
    }
    componentWillUnmount() {
        const { getQueryParams: getQueryParams, spaceKey: spaceKey, replace: replace } = this.props;
        if (this.state.isCreateDialogOpen) {
            const { ccProxyTarget: ccProxyTarget } = getQueryParams();
            if (ccProxyTarget) {
                const parsed = (0, $df017159f24bbbc7$export$65bf3eec2a811fa)(window.location.pathname, getQueryParams(), spaceKey);
                delete parsed.query.createDialog;
                delete parsed.query.ccProxyTarget;
                const newPath = (0, $jiJCD.format)({
                    origin: window.location.origin,
                    pathname: parsed.url,
                    query: parsed.query
                });
                replace(newPath);
            }
        }
    }
    render() {
        const { isCreateDialogOpen: isCreateDialogOpen, parentPageId: parentPageId, shouldSuppressDialog: shouldSuppressDialog, showVariableInputDrawer: showVariableInputDrawer } = this.state;
        return isCreateDialogOpen && !showVariableInputDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $detoO.PseudoCreateDialog), {
            key: "create",
            open: isCreateDialogOpen,
            onClose: this.closeDialog,
            shouldSuppressDialog: shouldSuppressDialog,
            parentPageId: parentPageId
        }) : null;
    }
    constructor(...args){
        super(...args);
        this.state = {
            isCreateDialogOpen: false,
            shouldSuppressDialog: false,
            showVariableInputDrawer: false
        };
        this.closeDialog = ()=>{
            const { setQueryParams: setQueryParams } = this.props;
            setQueryParams({
                createDialog: null,
                parentPageId: null
            });
        };
    }
}
$7a89639eeb268429$var$CreateDialogQueryRendererComponent.propTypes = {
    getQueryParams: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    setQueryParams: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    showVariableInputDrawer: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
const $7a89639eeb268429$export$dfc1613748f6bd0b = ()=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams, replace: replace } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { showTemplateVariableInputDrawer: showTemplateVariableInputDrawer } = (0, $42omo.useContext)((0, $8hUXc.CreateDialogContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Qugp.QueryRenderer), {
        queryMatcher: (0, $df017159f24bbbc7$export$a91aef22a1a3231b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES,
        modal: {
            onClose: ()=>setQueryParams({
                    createDialog: null,
                    parentPageId: null
                })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7a89639eeb268429$var$CreateDialogQueryRendererComponent, {
        getQueryParams: getQueryParams,
        setQueryParams: setQueryParams,
        replace: replace,
        spaceKey: spaceKey,
        showVariableInputDrawer: showTemplateVariableInputDrawer
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4QflW.LegacyCreateDialogCssOverridesLoader), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $87832188c5eb10c0$export$2e2bcd8739ae039), null));
};
module.exports["CreateDialogQueryRenderer"] = $7a89639eeb268429$export$dfc1613748f6bd0b;

});

parcelRegister("ln0hx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("5Lrkh", function(module, exports) {
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6qH8Q = parcelRequire("6qH8Q");

/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $d37921c2c4f77200$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6qH8Q.OuterWrapper), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6qH8Q.TitleWrapper), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6qH8Q.TitleContainer), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $l998X.jsx)((0, $6qH8Q.StyledTitleWrapper), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $l998X.jsx)((0, $6qH8Q.ActionsWrapper), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $l998X.jsxs)((0, $6qH8Q.BottomBarWrapper), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
var $d37921c2c4f77200$export$2e2bcd8739ae039 = $d37921c2c4f77200$var$PageHeader;
module.exports["default"] = $d37921c2c4f77200$export$2e2bcd8739ae039;

});

parcelRegister("6qH8Q", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $b15991625bedb0e5$var$styles = {
    bottomBar: "_1pfhpxbi"
};
const $b15991625bedb0e5$var$truncateStyles = null;
const $b15991625bedb0e5$var$outerStyles = null;
const $b15991625bedb0e5$var$titleStyles = null;
const $b15991625bedb0e5$var$titleWrapperStyles = null;
const $b15991625bedb0e5$var$titleWrapperTruncateStyles = null;
const $b15991625bedb0e5$var$titleContainerStyles = null;
const $b15991625bedb0e5$var$actionStyles = null;
const $b15991625bedb0e5$var$titleContainerTruncateStyles = null; /**
                                            * __Outer wrapper__.
                                            *
                                            * An outer wrapper that is the outermost component of the PageHeader component. It wraps around the PageHeader, its Actions,
                                            * the BottomBar and its Breadcrumbs.
                                            *
                                            */ 
const $b15991625bedb0e5$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
const $b15991625bedb0e5$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $gMc0m.default)([
            "_11c810sd _12ji1r31 _1qu2glyw _12y31o36 _syazi7uo _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
const $b15991625bedb0e5$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1y6m _1n261q9c",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
}; /**
    * Title container.
    *
    * A title container is a container that wraps around the title and its styles (if applied).
    *
    */ 
const $b15991625bedb0e5$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc _1i4q1hna",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
}; /**
    * __Actions wrapper__.
    *
    * An actions wrapper is a wrapper for the actions, which appear on the top right of the PageHeader component.
    *
    */ 
const $b15991625bedb0e5$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
}; /**
    * __Bottom bar wrapper__.
    *
    * A bottom bar wrapper is a wrapper for the bottom bar, which appears at the bottom of the PageHeader component.
    *
    */ 
const $b15991625bedb0e5$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b15991625bedb0e5$var$styles.bottomBar,
        children: children
    });
};
module.exports["OuterWrapper"] = $b15991625bedb0e5$export$edaaad985a878983;
module.exports["StyledTitleWrapper"] = $b15991625bedb0e5$export$284be1ee64a3465c;
module.exports["TitleWrapper"] = $b15991625bedb0e5$export$585a3b23e887288b;
module.exports["TitleContainer"] = $b15991625bedb0e5$export$35e09ba17cc51c69;
module.exports["ActionsWrapper"] = $b15991625bedb0e5$export$c8223871eecc8f3a;
module.exports["BottomBarWrapper"] = $b15991625bedb0e5$export$6330225854c30dc;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $frIzR.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("cqmCC", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $jiJCD = parcelRequire("jiJCD");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");

const $1805b22ab5ce9c71$export$98c2bfe563916273 = 'https://support.atlassian.com/contact/#/';
const $1805b22ab5ce9c71$var$getLinkText = (showHostname)=>showHostname ? (0, $jiJCD.parse)($1805b22ab5ce9c71$export$98c2bfe563916273).hostname : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "error-boundary.description.support-link",
        defaultMessage: "Atlassian Support"
    });
const $1805b22ab5ce9c71$export$f1bb9e069c7d2c = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { showHostname: showHostname, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== showHostname) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) ? children : $1805b22ab5ce9c71$var$getLinkText(showHostname);
        $[0] = children;
        $[1] = showHostname;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: $1805b22ab5ce9c71$export$98c2bfe563916273,
            target: "_blank"
        }, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["ATLASSIAN_SUPPORT_URL"] = $1805b22ab5ce9c71$export$98c2bfe563916273;
module.exports["AtlassianSupportLink"] = $1805b22ab5ce9c71$export$f1bb9e069c7d2c;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("gXsSh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7zgzO = parcelRequire("7zgzO");

function $fce7c419b91370d9$export$62d325d4ac84165c(WrappedComponent) {
    function WithRoutesContext(props) {
        const $ = (0, $frIzR.c)(3);
        const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
        let t0;
        if ($[0] !== props || $[1] !== routesContext) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                ...routesContext,
                ...props
            });
            $[0] = props;
            $[1] = routesContext;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    WithRoutesContext.displayName = `withRoutesContext(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithRoutesContext;
}
module.exports["withRoutesContext"] = $fce7c419b91370d9$export$62d325d4ac84165c;

});

parcelRegister("aRlro", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");

var $af18ba01e6766933$export$30b4791270845e3e = /*#__PURE__*/ function(GraphQLTemplateContentAppearance) {
    GraphQLTemplateContentAppearance["DEFAULT"] = "DEFAULT";
    GraphQLTemplateContentAppearance["FULL_WIDTH"] = "FULL_WIDTH";
    GraphQLTemplateContentAppearance["MAX"] = "MAX";
    return GraphQLTemplateContentAppearance;
}({});
const $af18ba01e6766933$var$_graphQLTemplateContentAppearanceToAtlaskitMap = {
    ["DEFAULT"]: (0, $1d2ww.ContentAppearanceType).DEFAULT,
    ["FULL_WIDTH"]: (0, $1d2ww.ContentAppearanceType).FULL_WIDTH,
    ["MAX"]: (0, $1d2ww.ContentAppearanceType).MAX
};
const $af18ba01e6766933$export$8d62bde47cfd2ae5 = (templateContentAppearance)=>$af18ba01e6766933$var$_graphQLTemplateContentAppearanceToAtlaskitMap[templateContentAppearance] || (0, $1d2ww.ContentAppearanceType).DEFAULT;
module.exports["GraphQLTemplateContentAppearance"] = $af18ba01e6766933$export$30b4791270845e3e;
module.exports["convertGraphQLTemplateContentAppearanceToContentAppearanceType"] = $af18ba01e6766933$export$8d62bde47cfd2ae5;

});

parcelRegister("lJDEI", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $4a3de077c1d50444$export$339879d9e7e1b505 = 'inEditorTemplatesPanel';
const $4a3de077c1d50444$export$a957a3414f664a78 = 'open';
const $4a3de077c1d50444$export$5f52a3f66b36af8a = 'keep_open';
const $4a3de077c1d50444$export$3077ff8b594d6ef8 = 'auto_closed';
const $4a3de077c1d50444$export$e03fa63b521a0c2 = 'createdWithTemplate';
const $4a3de077c1d50444$export$79a38b1b3ee7546f = 'contextPanelTabTarget';
const $4a3de077c1d50444$export$d3c15ca89bcfbca6 = 'templates';
const $4a3de077c1d50444$export$9d622978cb62b57d = 'block';
const $4a3de077c1d50444$export$3059f9ac1064e696 = 'import';
const $4a3de077c1d50444$export$ccd8928f1e8269de = 'templates';
const $4a3de077c1d50444$export$2f49124c0813d6f9 = 'import';
const $4a3de077c1d50444$export$5a50171a4c5c3a34 = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$e03fa63b521a0c2] === 'true';
};
const $4a3de077c1d50444$export$944cd488c360bc7a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$339879d9e7e1b505];
};
const $4a3de077c1d50444$export$c1ea49786444cf5a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$79a38b1b3ee7546f];
};
const $4a3de077c1d50444$export$e991edcb7a1d128f = (getQueryParams)=>{
    return $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams) === $4a3de077c1d50444$export$a957a3414f664a78;
};
const $4a3de077c1d50444$export$835e1f3b6fb2ce1a = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    return queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a;
};
const $4a3de077c1d50444$export$242446a58b76be13 = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    const tabTarget = $4a3de077c1d50444$export$c1ea49786444cf5a(getQueryParams);
    return (queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a) && (tabTarget === $4a3de077c1d50444$export$d3c15ca89bcfbca6 || tabTarget === $4a3de077c1d50444$export$9d622978cb62b57d);
};
const $4a3de077c1d50444$export$56073af4e8655248 = (setQueryParams)=>{
    const paramsToRemove = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: null
    };
    // Clear contextPanelTabTarget when either cc_snippets or cwr_blank_object_experiment is enabled
    if ((0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false)) paramsToRemove[$4a3de077c1d50444$export$79a38b1b3ee7546f] = null;
    setQueryParams(paramsToRemove, true);
};
const $4a3de077c1d50444$export$90fd502a25d2c01 = (setQueryParams, inEditorTemplatesPanel, tabTarget)=>{
    const params = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: inEditorTemplatesPanel
    };
    // Set contextPanelTabTarget when either cc_snippets or cwr_blank_object_experiment is enabled
    if (tabTarget && ((0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false))) params[$4a3de077c1d50444$export$79a38b1b3ee7546f] = tabTarget;
    setQueryParams(params, true);
};
const $4a3de077c1d50444$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
module.exports["IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$339879d9e7e1b505;
module.exports["IN_EDITOR_TEMPLATES_QUERY_OPEN"] = $4a3de077c1d50444$export$a957a3414f664a78;
module.exports["IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN"] = $4a3de077c1d50444$export$5f52a3f66b36af8a;
module.exports["IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED"] = $4a3de077c1d50444$export$3077ff8b594d6ef8;
module.exports["CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$e03fa63b521a0c2;
module.exports["CONTEXT_PANEL_TAB_TARGET"] = $4a3de077c1d50444$export$79a38b1b3ee7546f;
module.exports["CONTEXT_PANEL_TAB_TARGET_TEMPLATES"] = $4a3de077c1d50444$export$d3c15ca89bcfbca6;
module.exports["CONTEXT_PANEL_TAB_TARGET_BLOCK"] = $4a3de077c1d50444$export$9d622978cb62b57d;
module.exports["CONTEXT_PANEL_TAB_TARGET_IMPORT"] = $4a3de077c1d50444$export$3059f9ac1064e696;
module.exports["PANEL_MODE_TEMPLATES"] = $4a3de077c1d50444$export$ccd8928f1e8269de;
module.exports["PANEL_MODE_IMPORT"] = $4a3de077c1d50444$export$2f49124c0813d6f9;
module.exports["getCreatedWithTemplateQueryParamValue"] = $4a3de077c1d50444$export$5a50171a4c5c3a34;
module.exports["getInEditorTemplatesPanelQueryParamValue"] = $4a3de077c1d50444$export$944cd488c360bc7a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpen"] = $4a3de077c1d50444$export$e991edcb7a1d128f;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen"] = $4a3de077c1d50444$export$835e1f3b6fb2ce1a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpenWithTemplatesPanelMode"] = $4a3de077c1d50444$export$242446a58b76be13;
module.exports["removeInEditorTemplatesQueryParam"] = $4a3de077c1d50444$export$56073af4e8655248;
module.exports["setInEditorTemplatesPanelQueryParam"] = $4a3de077c1d50444$export$90fd502a25d2c01;
module.exports["getTemplateListPage"] = $4a3de077c1d50444$export$828af32839880b11;

});

parcelRegister("c4PY4", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $6mKj3 = parcelRequire("6mKj3");


var $1d2ww = parcelRequire("1d2ww");

const $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap = {
    [(0, $1d2ww.ContentAppearanceType).DEFAULT]: 'full-page',
    [(0, $1d2ww.ContentAppearanceType).FULL_WIDTH]: 'full-width',
    [(0, $1d2ww.ContentAppearanceType).MAX]: 'max'
};
const $e67a3bdaba93e18b$export$4ca444f48395eebe = (0, $2XqLN.default)((contentAppearance)=>{
    const appearanceForAtlaskit = $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[contentAppearance];
    // Fallback to 'full-width' if 'max' and experiment is off
    if (appearanceForAtlaskit === 'max' && !(0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && !(0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) return 'full-width';
    if (appearanceForAtlaskit) return appearanceForAtlaskit;
    return $e67a3bdaba93e18b$export$e79a6aa49fcbdebe();
});
const $e67a3bdaba93e18b$export$e79a6aa49fcbdebe = ()=>{
    return $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[(0, $1d2ww.ContentAppearanceType).DEFAULT];
};
module.exports["getContentAppearanceForAtlaskit"] = $e67a3bdaba93e18b$export$4ca444f48395eebe;

});

parcelRegister("jqe2L", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $jiJCD = parcelRequire("jiJCD");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $9wGTI = parcelRequire("9wGTI");

const $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled = ()=>{
    return (0, $9wGTI.fg)('confluence_frontend_fabric_editor_blank_page') || (0, $9wGTI.fg)('confluence_frontend_fabric_editor_all_pages');
};
const $350735cb5bb3c1ba$export$9d03777b293b05ce = ()=>{
    return $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled();
};
const $350735cb5bb3c1ba$export$c8780cd30055dcb8 = (parentPageResponse, creationSpaceKey)=>{
    // parent page is in the selected space
    const spaceKey = parentPageResponse?.content?.nodes?.[0]?.space?.key;
    if (spaceKey !== creationSpaceKey) return false;
    // ancestors must be of the same content Type
    const contentType = parentPageResponse?.content?.nodes?.[0]?.type;
    if (contentType !== 'page') return false;
    // parent page must not be archived
    const status = parentPageResponse?.content?.nodes?.[0]?.status;
    if (status === 'archived') return false;
    // must have create access under the parent page
    const operations = parentPageResponse?.content?.nodes?.[0]?.operations;
    const hasCreateOperation = operations && operations.find((op)=>op?.targetType === 'page' && op.operation === 'create');
    return !!hasCreateOperation;
};
const $350735cb5bb3c1ba$export$4c6171230e6eef02 = (overrideValue, defaultValue)=>{
    return {
        value: overrideValue || defaultValue,
        usedOverride: !!overrideValue
    };
};
const $350735cb5bb3c1ba$export$a0b32aef6b0d7373 = (urlToChange, params, updateEditorMode)=>{
    updateEditorMode?.('create-page');
    const urlComponents = (0, $jiJCD.parse)(urlToChange, true);
    return (0, $jiJCD.format)({
        ...urlComponents,
        // remove `search`, otherwise
        // `query` will be ignored
        search: undefined,
        query: {
            ...urlComponents.query,
            ...params
        }
    });
};
const $350735cb5bb3c1ba$export$f59f47d22cf7d84d = (url)=>{
    if (!url) throw new Error('No url for new content');
    if (url.startsWith((0, $jlIaF.CONTEXT_PATH))) return url;
    return `${0, $jlIaF.CONTEXT_PATH}${url}`;
};
const $350735cb5bb3c1ba$export$cca9db3da8f2e4f8 = ({ spaceKey: spaceKey, contentId: contentId, url: url, type: type = 'page' })=>{
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(url);
    const draftShareId = legacyDraftRouteMatch?.query?.draftShareId || '';
    const editV2Url = type === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        contentType: 'blog',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    }) : (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        contentType: 'pages',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    });
    return $350735cb5bb3c1ba$export$f59f47d22cf7d84d(editV2Url);
};
const $350735cb5bb3c1ba$export$b47a1345d675bf12 = (error, messageMatches)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>messageMatches.some((messageMatch)=>message.includes(messageMatch)));
    return false;
};
module.exports["isCreateBlankFabricPageEnabled"] = $350735cb5bb3c1ba$export$9d03777b293b05ce;
module.exports["appendQueryParams"] = $350735cb5bb3c1ba$export$a0b32aef6b0d7373;
module.exports["processDraftUrl"] = $350735cb5bb3c1ba$export$f59f47d22cf7d84d;
module.exports["getEditPageUrl"] = $350735cb5bb3c1ba$export$cca9db3da8f2e4f8;
module.exports["graphqlErrorHasMessage"] = $350735cb5bb3c1ba$export$b47a1345d675bf12;

});

parcelRegister("fBjVq", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3141cf32c54bf764$var$RendererLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AfRhk",
    // Name needs to match the one in next/packages/view-page/src/index.ts
    name: "ClassicRendererLoader",
    loader: ()=>(parcelRequire("2SVac"))
});
var $3141cf32c54bf764$export$2e2bcd8739ae039 = $3141cf32c54bf764$var$RendererLoader;
module.exports["default"] = $3141cf32c54bf764$export$2e2bcd8739ae039;

});

parcelRegister("2SVac", function(module, exports) {

let $219cf766f816a554$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $219cf766f816a554$var$load("h3ABO"),
    $219cf766f816a554$var$load("2YffH"),
    $219cf766f816a554$var$load("9xpV4"),
    $219cf766f816a554$var$load("k5vHn"),
    $219cf766f816a554$var$load("hJpvQ"),
    $219cf766f816a554$var$load("bBnlP"),
    $219cf766f816a554$var$load("2F69B"),
    $219cf766f816a554$var$load("iP4fd"),
    $219cf766f816a554$var$load("eiF7i"),
    $219cf766f816a554$var$load("aZinD"),
    $219cf766f816a554$var$load("gLGsg"),
    $219cf766f816a554$var$load("fJtJG"),
    $219cf766f816a554$var$load("bogQM"),
    $219cf766f816a554$var$load("jq3Ai"),
    $219cf766f816a554$var$load("lkOIY"),
    $219cf766f816a554$var$load("2Yzw6"),
    $219cf766f816a554$var$load("jwWp5"),
    $219cf766f816a554$var$load("dHMdi"),
    $219cf766f816a554$var$load("lId0W"),
    $219cf766f816a554$var$load("7do1E"),
    $219cf766f816a554$var$load("77dkW"),
    $219cf766f816a554$var$load("8j9XC"),
    $219cf766f816a554$var$load("3w411"),
    $219cf766f816a554$var$load("fSobj"),
    $219cf766f816a554$var$load("74u2y"),
    $219cf766f816a554$var$load("cyGuT"),
    $219cf766f816a554$var$load("6wr18"),
    $219cf766f816a554$var$load("kjZZD"),
    $219cf766f816a554$var$load("9u7sS"),
    $219cf766f816a554$var$load("1fem1"),
    $219cf766f816a554$var$load("ffEVr"),
    $219cf766f816a554$var$load("4EvEa"),
    $219cf766f816a554$var$load("2h6rN"),
    $219cf766f816a554$var$load("9fvYm"),
    $219cf766f816a554$var$load("im1Yv"),
    $219cf766f816a554$var$load("6mxDS"),
    $219cf766f816a554$var$load("3Wg31"),
    $219cf766f816a554$var$load("fZt2F"),
    $219cf766f816a554$var$load("6ffwi"),
    $219cf766f816a554$var$load("henq4"),
    $219cf766f816a554$var$load("1hb17"),
    $219cf766f816a554$var$load("l6yNt"),
    $219cf766f816a554$var$load("hogcU"),
    $219cf766f816a554$var$load("2vAWg"),
    $219cf766f816a554$var$load("7cABH"),
    $219cf766f816a554$var$load("dAdaw"),
    $219cf766f816a554$var$load("2uVTT"),
    $219cf766f816a554$var$load("aOQqp"),
    $219cf766f816a554$var$load("1FeuN"),
    $219cf766f816a554$var$load("lrSMb"),
    $219cf766f816a554$var$load("hhss7"),
    $219cf766f816a554$var$load("Wowvf"),
    $219cf766f816a554$var$load("cJcjb"),
    $219cf766f816a554$var$load("t7GWU"),
    $219cf766f816a554$var$load("7OBED"),
    $219cf766f816a554$var$load("2YGw3"),
    $219cf766f816a554$var$load("7aOpi"),
    $219cf766f816a554$var$load("beE2d"),
    $219cf766f816a554$var$load("dUQPx"),
    $219cf766f816a554$var$load("cikky"),
    $219cf766f816a554$var$load("3nGwp"),
    $219cf766f816a554$var$load("7EorR"),
    $219cf766f816a554$var$load("8CeYz")
]).then(()=>parcelRequire('djmKw'));

});

parcelRegister("6mzxy", function(module, exports) {
/// <reference types="node" />
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5dBQh = parcelRequire("5dBQh");


var $gxtzC = parcelRequire("gxtzC");


var $iug2J = parcelRequire("iug2J");

var $16xFS = parcelRequire("16xFS");


var $caX7N = parcelRequire("caX7N");


var $QWZ7H = parcelRequire("QWZ7H");


var $8nE2r = parcelRequire("8nE2r");

// escape close manager for layering
const $cab225b650e55c9a$var$EscapeCloseManager = ({ onClose: onClose })=>{
    // wrap so that we can cast the event to a React.KeyboardEvent
    const handleClose = (0, $42omo.useCallback)((evt)=>{
        onClose && onClose(evt);
    }, [
        onClose
    ]);
    (0, $16xFS.useCloseOnEscapePress)({
        onClose: handleClose
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {});
};
const $cab225b650e55c9a$export$4071300121a182f5 = ({ width: width = 'narrow', isOpen: isOpen, isFocusLockEnabled: isFocusLockEnabled = true, shouldReturnFocus: shouldReturnFocus = true, autoFocusFirstElem: autoFocusFirstElem = true, onKeyDown: onKeyDown, testId: testId, children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, zIndex: zIndex = 'unset', label: label, titleId: titleId, enterFrom: enterFrom })=>{
    const handleClose = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'escKey'
        }
    });
    const handleKeyDown = (0, $42omo.useCallback)((evt)=>{
        onKeyDown && onKeyDown(evt);
    }, [
        onKeyDown
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isOpen) window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleKeyDown,
        isOpen
    ]);
    const handleBlanketClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'blanket'
        }
    });
    const handleBackButtonClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'backButton'
        }
    });
    const body = (0, $5dBQh.canUseDOM) ? document.querySelector('body') : undefined;
    if (!body) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $caX7N.default), {
        zIndex: zIndex,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $QWZ7H.default), {
                isOpen: isOpen,
                onBlanketClicked: handleBlanketClick,
                testId: testId && `${testId}--blanket`
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $8nE2r.DrawerPanel), {
                testId: testId,
                isOpen: isOpen,
                onClose: handleBackButtonClick,
                onCloseComplete: onCloseComplete,
                onOpenComplete: onOpenComplete,
                width: width,
                enterFrom: enterFrom,
                label: label,
                titleId: titleId,
                autoFocusFirstElem: autoFocusFirstElem,
                isFocusLockEnabled: isFocusLockEnabled,
                shouldReturnFocus: shouldReturnFocus,
                children: isOpen ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $iug2J.Layering), {
                    isDisabled: false,
                    children: [
                        children,
                        /*#__PURE__*/ (0, $l998X.jsx)($cab225b650e55c9a$var$EscapeCloseManager, {
                            onClose: handleClose
                        })
                    ]
                }) : children
            })
        ]
    });
};
module.exports["Drawer"] = $cab225b650e55c9a$export$4071300121a182f5;

});

parcelRegister("QWZ7H", function(module, exports) {
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");


var $4kfV4 = parcelRequire("4kfV4");


var $g9Srd = parcelRequire("g9Srd");

var $fT2ta = parcelRequire("fT2ta");

const $7b8027d9ded03615$var$styles = {
    blanket: "_kqswh2mm"
}; /**
    * A wrapper around `@atlaskit/blanket` that adds a fade in/out transition.
    */ 
const $7b8027d9ded03615$var$Blanket = ({ isOpen: isOpen, onBlanketClicked: onBlanketClicked, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default /*
                       * The fade out animation uses half the passed duration so it evens out.
                       */ ), {
            duration: "large",
            /**
                                            * We don't expose this on `FadeIn` but it does get passed down.
                                            * TODO: figure out how we want to handle this...
                                            */ // @ts-ignore
            animationTimingFunction: "ease-out",
            children: ({ className: className })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $7b8027d9ded03615$var$styles.blanket,
                        className
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4kfV4.default), {
                        isTinted: true,
                        onBlanketClicked: onBlanketClicked,
                        testId: testId && testId
                    })
                })
        })
    });
};
var $7b8027d9ded03615$export$2e2bcd8739ae039 = $7b8027d9ded03615$var$Blanket;
module.exports["default"] = $7b8027d9ded03615$export$2e2bcd8739ae039;

});

parcelRegister("8nE2r", function(module, exports) {
/* drawer-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $g9Srd = parcelRequire("g9Srd");

var $h3cbw = parcelRequire("h3cbw");


var $bYDHH = parcelRequire("bYDHH");


var $cQbMg = parcelRequire("cQbMg");

const $84a03d0652bf4de0$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $84a03d0652bf4de0$var$styles = {
    root: "_1reo15vq _18m915vq _1e0c1txw _4t3i1kxc _kqsw1n9t _1pbybfng _bfhk1bhr _1q1l1bhr _152tze3t _1e02ze3t _ect4ttxp",
    full: "_1bsbauwl",
    extended: "_1bsb1mwr",
    narrow: "_1bsb1gwv",
    medium: "_1bsb1y37",
    wide: "_1bsb1ogm"
}; /**
    * This wrapper is used to specify separate durations for enter and exit.
    */ 
const $84a03d0652bf4de0$var$CustomSlideIn = ({ children: children, onFinish: onFinish, enterFrom: enterFrom })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $h3cbw.default), {
        animationTimingFunction: "ease-out",
        duration: "small",
        enterFrom: enterFrom,
        exitTo: enterFrom,
        fade: "none",
        onFinish: onFinish,
        children: children
    });
}; /**
    * __Drawer panel__
    */ 
const $84a03d0652bf4de0$export$96114a266f19b4d0 = ({ children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, testId: testId, isOpen: isOpen, shouldReturnFocus: shouldReturnFocus, autoFocusFirstElem: autoFocusFirstElem, isFocusLockEnabled: isFocusLockEnabled, width: width = 'narrow', label: label, titleId: titleId, enterFrom: enterFrom = 'left' })=>{
    /**
   * A ref to point to our wrapper, passed to `onCloseComplete` and `onOpenComplete` callbacks.
   */ const drawerRef = (0, $42omo.useRef)(null);
    const onFinish = (0, $42omo.useCallback)((state)=>{
        if (state === 'entering') onOpenComplete?.(drawerRef.current);
        else if (state === 'exiting') onCloseComplete?.(drawerRef.current);
    }, [
        onCloseComplete,
        onOpenComplete
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsx)($84a03d0652bf4de0$var$CustomSlideIn, {
            onFinish: onFinish,
            enterFrom: enterFrom,
            children: ({ className: className })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $cQbMg.default), {
                    autoFocusFirstElem: autoFocusFirstElem,
                    isFocusLockEnabled: isFocusLockEnabled,
                    shouldReturnFocus: shouldReturnFocus,
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    , {
                        className: (0, $gMc0m.default)([
                            $84a03d0652bf4de0$var$styles.root,
                            $84a03d0652bf4de0$var$styles[width],
                            className
                        ]),
                        "data-testid": testId,
                        ref: drawerRef,
                        "aria-modal": true,
                        role: "dialog",
                        "aria-label": label,
                        "aria-labelledby": titleId,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYDHH.EnsureIsInsideDrawerContext).Provider, {
                            value: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYDHH.OnCloseContext).Provider, {
                                value: onClose,
                                children: children
                            })
                        })
                    })
                })
        })
    });
};
module.exports["DrawerPanel"] = $84a03d0652bf4de0$export$96114a266f19b4d0;

});

parcelRegister("bYDHH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");

const $8d7383d6bcc82e3d$export$7376ab1fc7707bdd = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $8d7383d6bcc82e3d$export$c2b12c82f332a6fb = ()=>(0, $42omo.useContext)($8d7383d6bcc82e3d$export$7376ab1fc7707bdd);
const $8d7383d6bcc82e3d$export$e3662b8677049786 = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $8d7383d6bcc82e3d$export$780b9799f6bfecd8 = ()=>{
    const context = (0, $42omo.useContext)($8d7383d6bcc82e3d$export$e3662b8677049786);
    (0, $dRnqM.default)(context, 'Drawer sub-components must be used within a Drawer component.');
};
module.exports["OnCloseContext"] = $8d7383d6bcc82e3d$export$7376ab1fc7707bdd;
module.exports["useOnClose"] = $8d7383d6bcc82e3d$export$c2b12c82f332a6fb;
module.exports["EnsureIsInsideDrawerContext"] = $8d7383d6bcc82e3d$export$e3662b8677049786;
module.exports["useEnsureIsInsideDrawer"] = $8d7383d6bcc82e3d$export$780b9799f6bfecd8;

});

parcelRegister("cQbMg", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5zdke = parcelRequire("5zdke");

/**
 * __Focus lock__
 *
 * Thin wrapper around react-focus-lock.
 */ const $9fec633bae07d25d$var$FocusLock = ({ isFocusLockEnabled: isFocusLockEnabled = true, autoFocusFirstElem: autoFocusFirstElem = true, shouldReturnFocus: shouldReturnFocus = true, children: children })=>{
    const getFocusTarget = ()=>{
        if (typeof shouldReturnFocus === 'boolean') return shouldReturnFocus;
        return false;
    };
    const onDeactivation = ()=>{
        if (typeof shouldReturnFocus !== 'boolean') window.setTimeout(()=>{
            shouldReturnFocus?.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5zdke.default), {
        disabled: !isFocusLockEnabled,
        autoFocus: autoFocusFirstElem,
        returnFocus: getFocusTarget(),
        onDeactivation: onDeactivation,
        children: children
    });
};
var $9fec633bae07d25d$export$2e2bcd8739ae039 = $9fec633bae07d25d$var$FocusLock;
module.exports["default"] = $9fec633bae07d25d$export$2e2bcd8739ae039;

});

parcelRegister("kVCDE", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $bPdpL = parcelRequire("bPdpL");


var $bYDHH = parcelRequire("bYDHH");

const $eadefab640f31c2f$export$d0c3a75c17ac0cab = ({ icon: Icon, label: label = 'Close drawer', testId: testId = 'DrawerCloseButton' })=>{
    (0, $bYDHH.useEnsureIsInsideDrawer)();
    const onClose = (0, $bYDHH.useOnClose)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        onClick: onClose,
        testId: testId,
        icon: Icon ? (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                ...iconProps,
                size: "large"
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))),
        label: label,
        shape: "circle",
        appearance: "subtle"
    });
};
module.exports["DrawerCloseButton"] = $eadefab640f31c2f$export$d0c3a75c17ac0cab;

});

parcelRegister("4CUNa", function(module, exports) {
/* drawer-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $crya1 = parcelRequire("crya1");


var $4rwCt = parcelRequire("4rwCt");


var $bYDHH = parcelRequire("bYDHH");


var $alJT5 = parcelRequire("alJT5");

const $d84b625bc49f9cf4$var$styles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug _19pk1ejb"
};
const $d84b625bc49f9cf4$var$DrawerContentBase = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, scrollContentLabel: scrollContentLabel = 'Scrollable content', xcss: xcss }, scrollableRef)=>{
    const [showContentFocus, setContentFocus] = (0, $42omo.useState)(false);
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const setLazyContentFocus = ()=>{
            const target = ref.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        };
        setLazyContentFocus();
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $d84b625bc49f9cf4$var$styles.default,
            xcss
        ]),
        ref: (0, $4rwCt.mergeRefs)([
            ref,
            scrollableRef
        ]),
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? scrollContentLabel : undefined,
        "data-testid": "drawer-contents",
        children: children
    });
});
const $d84b625bc49f9cf4$export$57ca055474bc0056 = ({ children: children, scrollContentLabel: scrollContentLabel, xcss: xcss })=>{
    (0, $bYDHH.useEnsureIsInsideDrawer)();
    (0, $alJT5.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($crya1))), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($d84b625bc49f9cf4$var$DrawerContentBase, {
            scrollContentLabel: scrollContentLabel,
            xcss: xcss,
            children: children
        })
    });
};
module.exports["DrawerContent"] = $d84b625bc49f9cf4$export$57ca055474bc0056;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("alJT5", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7a79670dbf4af9f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");

/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 * ⚠️ This is copied from `packages/design-system/modal-dialog/src/internal/hooks/use-prevent-programmatic-scroll.tsx`
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $c7a79670dbf4af9f$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $c7a79670dbf4af9f$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $42omo.useState)(0);
    (0, $42omo.useLayoutEffect)(()=>{
        setScrollTopOffset($c7a79670dbf4af9f$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $42omo.useCallback)(()=>{
        if ($c7a79670dbf4af9f$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $42omo.useEffect)(()=>{
        return (0, $fFa3V.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("4GGNn", function(module, exports) {

var $GLgaM = parcelRequire("GLgaM");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError }) {
    const json = await (0, $GLgaM.fetchResponse)({
        url: url,
        method: method,
        body: body,
        headers: headers,
        credentials: credentials,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    }, variables);
    const data = await parseResult(json, variables);
    return {
        data: data
    };
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("bZ9Ng", function(module, exports) {
/* This module exports shared functions used by both blueprint & template endpoints, as these REST APIs share similar
 * request/response patterns.
 */ // eslint-disable-next-line no-restricted-imports

var $hBkCm = parcelRequire("hBkCm");


var $dw6y2 = parcelRequire("dw6y2");

const $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f = (json)=>{
    const title = json?.content?.title;
    return {
        content: {
            id: json?.content?.id || null,
            type: 'page',
            subType: json?.content?.subType || null,
            title: typeof title === 'string' ? title : null,
            space: {
                key: json?.content?.space?.key || null
            },
            _links: {
                editui: json?.content?._links?.editui || null
            },
            metadata: {
                properties: {
                    editor: {
                        value: json?.content?.metadata?.properties?.editor?.value || null
                    }
                },
                simple: {
                    isFabric: json?.content?.metadata?.simple?.isFabric || null
                }
            }
        }
    };
};
const $2dc0a210c1f3c9f7$export$ed7023388c8f5dd4 = async (cfetch, url, method, headers, pageData)=>{
    const MAX_CONTENT_UPDATE_RETRY = 1;
    const updateTemplate = async (count = 0)=>{
        try {
            const res = await cfetch(url, {
                method: method,
                headers: headers,
                body: JSON.stringify(pageData)
            });
            return res.json();
        } catch (err) {
            const errorStatus = err?.response?.status;
            if (errorStatus === 500) {
                const backendError = await err.response.json();
                throw new (0, $hBkCm.BadStatusError)(backendError.errorMessage, err.response);
            }
            if (count < MAX_CONTENT_UPDATE_RETRY && errorStatus === 409) return updateTemplate(++count);
            throw err;
        }
    };
    const json = await updateTemplate();
    return $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f(json);
};
const $2dc0a210c1f3c9f7$export$6a221318e0d372a4 = async (createPageResponseJson, attemptSpaUrl)=>{
    if (attemptSpaUrl) {
        // TODO: remove the old metadata field check once we use the new metadata field for template
        const isFabric = createPageResponseJson?.content?.metadata?.properties?.editor?.value === 'v2' || createPageResponseJson?.content?.metadata?.simple?.isFabric === true;
        const isLivePage = createPageResponseJson?.content?.subType === 'live';
        if (isLivePage) return createPageResponseJson?.content?._links?.editui;
        if (isFabric) return (0, $dw6y2.createEditDraftPageUrl)(createPageResponseJson);
    }
    return createPageResponseJson?.content?._links?.editui;
};
module.exports["getOnContentUpdatedObjFromResponse"] = $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f;
module.exports["getEditDraftPageUrl"] = $2dc0a210c1f3c9f7$export$6a221318e0d372a4;

});

parcelRegister("dw6y2", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jFumb = parcelRequire("jFumb");

const $5df2cb75c6140959$export$2b48bde4878a8630 = (metadata)=>{
    const data = 'content' in metadata ? metadata.content : metadata;
    const spaceKey = data?.space?.key;
    const subType = data?.subType;
    if (!spaceKey) return data._links.editui;
    if (subType === 'live') return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: data?.id
    });
    return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentId: data?.id,
        contentType: 'pages'
    }, {
        query: {
            draftShareId: (0, $jFumb.getDraftShareIdFromCreateContentMetadata)(data)
        }
    });
};
const $5df2cb75c6140959$export$4a4b0cb92802bec5 = (metadata)=>{
    const spaceAlias = metadata?.space?.alias;
    if (!spaceAlias) return metadata._links.editui;
    return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceAlias,
        contentId: metadata?.id,
        contentType: 'blog'
    }, {
        query: {
            draftShareId: (0, $jFumb.getDraftShareIdFromCreateContentMetadata)(metadata)
        }
    });
};
module.exports["createEditDraftPageUrl"] = $5df2cb75c6140959$export$2b48bde4878a8630;
module.exports["createEditDraftBlogUrl"] = $5df2cb75c6140959$export$4a4b0cb92802bec5;

});

parcelRegister("jFumb", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $517b1e1152d7e308$export$251fafe6ead5eb49 = (data)=>{
    const context = data?._links?.context || (0, $jlIaF.CONTEXT_PATH);
    const legacyUrl = data?._links?.editui || '';
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(context + legacyUrl);
    const id = legacyDraftRouteMatch?.query?.draftShareId;
    const draftShareId = Array.isArray(id) ? id[0] : id;
    return draftShareId || '';
};
module.exports["getDraftShareIdFromCreateContentMetadata"] = $517b1e1152d7e308$export$251fafe6ead5eb49;

});

parcelRegister("3Qugp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $7zgzO = parcelRequire("7zgzO");

class $2828475a3b6fbbbf$export$ddc6aa096985699a extends (0, $42omo.Component) {
    render() {
        const { children: children, queryMatcher: queryMatcher } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams })=>children && queryMatcher(getQueryParams()) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children) : null);
    }
}
$2828475a3b6fbbbf$export$ddc6aa096985699a.propTypes = {
    queryMatcher: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node
};
module.exports["QueryRenderer"] = $2828475a3b6fbbbf$export$ddc6aa096985699a;

});

parcelRegister("cEgln", function(module, exports) {
$parcel$export(module.exports, "trigger", () => (parcelRequire("3IK76")).trigger);
$parcel$export(module.exports, "bind", () => (parcelRequire("3IK76")).bind);
$parcel$export(module.exports, "unbind", () => (parcelRequire("3IK76")).unbind);

var $3IK76 = parcelRequire("3IK76");


});

parcelRegister("3IK76", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $jnN7b = parcelRequire("jnN7b");

function $2b59405ae3db7385$export$2385a24977818dd0(eventType, eventData, handler) {
    if (typeof handler === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData, handler);
    else return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData);
}
function $2b59405ae3db7385$export$433e98592e7124fd(eventType, handler) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).unbind(eventType, handler);
}
function $2b59405ae3db7385$export$e614dc9140f7ae71(eventType, extraParameters) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).trigger(eventType, extraParameters);
}
module.exports["bind"] = $2b59405ae3db7385$export$2385a24977818dd0;
module.exports["unbind"] = $2b59405ae3db7385$export$433e98592e7124fd;
module.exports["trigger"] = $2b59405ae3db7385$export$e614dc9140f7ae71;

});

parcelRegister("jnN7b", function(module, exports) {
module.exports = jQuery;

});

parcelRegister("cSdzn", function(module, exports) {
$parcel$export(module.exports, "default", () => $95f50dcfd27e28ce$export$2e2bcd8739ae039);
function $95f50dcfd27e28ce$var$isDefined(path) {
    const pathParts = path.split('.');
    let obj = window[pathParts.shift()];
    while(typeof obj !== 'undefined' && pathParts.length)obj = obj[pathParts.shift()];
    return obj;
}
const $95f50dcfd27e28ce$var$lines = {};
function $95f50dcfd27e28ce$var$logOnce(message) {}
function $95f50dcfd27e28ce$export$d2adf65b87e47523() {
    for(const key in $95f50dcfd27e28ce$var$lines)delete $95f50dcfd27e28ce$var$lines[key];
}
function $95f50dcfd27e28ce$export$2e2bcd8739ae039({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($95f50dcfd27e28ce$var$isDefined(globalProperty)) {
        $95f50dcfd27e28ce$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $95f50dcfd27e28ce$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($95f50dcfd27e28ce$var$isDefined(globalProperty)) {
            $95f50dcfd27e28ce$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
    return {
        cancel () {
            if (waitForGlobalInterval) clearInterval(waitForGlobalInterval);
        }
    };
}

});

parcelRegister("lolFL", function(module, exports) {
$parcel$export(module.exports, "default", () => $f92ca69b0d771a19$export$2e2bcd8739ae039);

var $6g1oe = parcelRequire("6g1oe");


var $cSdzn = parcelRequire("cSdzn");

function $f92ca69b0d771a19$export$dfb0c4efd029859d(module) {
    try {
        (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $f92ca69b0d771a19$export$2e2bcd8739ae039({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $cSdzn.default)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($f92ca69b0d771a19$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($f92ca69b0d771a19$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}

});

parcelRegister("fU6PL", function(module, exports) {
/* istanbul ignore next */ function $b941630dfdd9456a$export$89e12c5b50f7529d(url) {
    window.location = url;
}
function $b941630dfdd9456a$export$17b07c660794dc13() {
    if (typeof window !== 'undefined') return window.location;
    else return undefined;
}
function $b941630dfdd9456a$export$f710a83a91838a36() {
    if (typeof window === 'undefined' || !window.location) return undefined;
    let origin = window.location.origin;
    if (!origin) origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
    return origin;
}
function $b941630dfdd9456a$export$32da5b5043dcd88c() {
    if (typeof window !== 'undefined') window.location.reload();
}
function $b941630dfdd9456a$export$715f9d76bb8c1fea(message) {
    if (typeof window === 'undefined') return true;
    return window.confirm(message);
}
function $b941630dfdd9456a$export$3f65cefe8380dbea(...args) {
    if (typeof window !== 'undefined') window.addEventListener.apply(window, args);
}
function $b941630dfdd9456a$export$8ff9f68337b520c0(...args) {
    if (typeof window !== 'undefined') window.removeEventListener.apply(window, args);
}
function $b941630dfdd9456a$export$3ef1368fc1aa92de(element) {
    if (typeof window === 'undefined') return element.offsetHeight;
    const style = window.getComputedStyle(element);
    const height = element.offsetHeight;
    return height + parseInt(style.marginTop) + parseInt(style.marginBottom);
}
function $b941630dfdd9456a$export$5a2da8cd883b1f88(element) {
    if (typeof window === 'undefined') return element.offsetHeight;
    const style = window.getComputedStyle(element);
    const height = element.offsetHeight;
    return height - parseInt(style.paddingTop) - parseInt(style.paddingBottom) - parseInt(style.borderTopWidth) - parseInt(style.borderBottomWidth);
}
function $b941630dfdd9456a$export$18e9b0709c75d4c5(element) {
    if (typeof window === 'undefined') return element.offsetWidth;
    const style = window.getComputedStyle(element);
    const width = element.offsetWidth;
    return width + parseInt(style.marginLeft) + parseInt(style.marginRight);
}
function $b941630dfdd9456a$export$fd39c00f94741b03() {
    if (typeof window === 'undefined') return 0;
    return window.pageYOffset;
}
function $b941630dfdd9456a$export$d23fbaf1a2e7133c() {
    if (typeof window === 'undefined') return 0;
    return window.innerWidth;
}
function $b941630dfdd9456a$export$d3ad305c42af1069() {
    if (typeof window === 'undefined') return 0;
    return window.innerHeight;
}
function $b941630dfdd9456a$export$6cb2c4c0a22909c0() {
    const window1 = window1 || {};
    const polyfill = (callback)=>{
        setTimeout(callback, 1000 / 60);
    };
    return window1.requestAnimationFrame || polyfill;
}
function $b941630dfdd9456a$export$139d5ccee31f82f4(...args) {
    if (!window) return;
    if (!window.require) return;
    return window.require.apply(window, args);
}
function $b941630dfdd9456a$export$f9582a3c130d9538() {
    if (typeof window === 'undefined') return 0;
    return window.history;
}
function $b941630dfdd9456a$export$38b2d434cce3ea22() {
    return window;
}
module.exports["reload"] = $b941630dfdd9456a$export$32da5b5043dcd88c;
module.exports["confirm"] = $b941630dfdd9456a$export$715f9d76bb8c1fea;
module.exports["addEventListener"] = $b941630dfdd9456a$export$3f65cefe8380dbea;
module.exports["removeEventListener"] = $b941630dfdd9456a$export$8ff9f68337b520c0;
module.exports["globalRequire"] = $b941630dfdd9456a$export$139d5ccee31f82f4;
module.exports["getWindow"] = $b941630dfdd9456a$export$38b2d434cce3ea22;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("2BQQi", function(module, exports) {

var $auRWi = parcelRequire("auRWi");


var $jMyy4 = parcelRequire("jMyy4");

const $513635d9ade3aacb$var$UseInlineHighlightsQuery = (0, $auRWi.default);
const $513635d9ade3aacb$export$7a17e81d6650ad94 = ({ pageId: pageId, shouldFireQuery: shouldFireQuery = true })=>{
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($513635d9ade3aacb$var$UseInlineHighlightsQuery, {
        variables: {
            pageId: pageId
        },
        skip: !Boolean(shouldFireQuery)
    });
    let markerRefs = [];
    let markerRefMap = {};
    const comments = data?.comments?.nodes;
    if (comments && Array.isArray(comments)) {
        // We need to create a map that connects markerRefs to commentId, we need commentId to fire analytic event
        // https://github.com/microsoft/TypeScript/issues/17002 - for type casting
        markerRefMap = comments.reduce((inlineRefAccumulator, comment)=>{
            if (!comment) return inlineRefAccumulator;
            const { inlineMarkerRef: inlineMarkerRef } = comment.location;
            // We should always get top-level inline comments, but if this doesn't exist, just return
            if (!inlineMarkerRef) return inlineRefAccumulator;
            inlineRefAccumulator[comment?.id] = inlineMarkerRef;
            comment?.replies?.forEach((reply)=>{
                if (reply) {
                    const { id: replyId } = reply;
                    inlineRefAccumulator[replyId] = inlineMarkerRef;
                }
            });
            return inlineRefAccumulator;
        }, {});
        markerRefs = [
            ...new Set(Object.values(markerRefMap))
        ];
    }
    return {
        markerRefs: markerRefs,
        markerRefMap: markerRefMap,
        loading: loading
    };
};
module.exports["useInlineHighlights"] = $513635d9ade3aacb$export$7a17e81d6650ad94;

});

parcelRegister("auRWi", function(module, exports) {
/**
 * @generated SignedSource<<ae6c0cd0e6b2ccebe266c857fe0c5bfd>>
 * @relayHash 1d98f028d17ad9f621bdfdae3f304d7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d1c7df039b34325b1be8894b47edfe979cd0fcb6539236903815bb381b9b21d
const $e084fe268cd37421$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            }
        ],
        "type": "InlineComment"
    }, v5 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useInlineHighlightsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useInlineHighlightsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1d98f028d17ad9f621bdfdae3f304d7b",
            "id": "4d1c7df039b34325b1be8894b47edfe979cd0fcb6539236903815bb381b9b21d",
            "metadata": {},
            "name": "useInlineHighlightsQuery",
            "operationKind": "query",
            "text": "query useInlineHighlightsQuery($pageId:ID!){comments(pageId:$pageId,type:UNRESOLVED,depth:ROOT,first:1000){nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef}},replies{id}}}}"
        }
    };
}();
$e084fe268cd37421$var$node.hash = "2fb3b51eea98e2fd2a940548824e472b";
var $e084fe268cd37421$export$2e2bcd8739ae039 = $e084fe268cd37421$var$node;
module.exports["default"] = $e084fe268cd37421$export$2e2bcd8739ae039;

});

parcelRegister("detoO", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $7W8i8 = parcelRequire("7W8i8");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $joCMa = parcelRequire("joCMa");








var $6g1oe = parcelRequire("6g1oe");


var $eXODy = parcelRequire("eXODy");

parcelRequire("cEgln");
var $3IK76 = parcelRequire("3IK76");


var $cSdzn = parcelRequire("cSdzn");


var $lolFL = parcelRequire("lolFL");


var $fU6PL = parcelRequire("fU6PL");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $cpjd2 = parcelRequire("cpjd2");

class $b12964423d7a55a9$export$96127edb89d86a28 extends (0, $42omo.PureComponent) {
    componentDidMount() {
        (0, $3IK76.bind)('remove.dialog', this._afterDialogClosed);
        this.forceReloadInNextOpen = true;
        this._setOpenState(this.props.open);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.spaceKey !== nextProps.spaceKey) this.forceReloadInNextOpen = true;
        if (nextProps.open) (0, $eXODy.nativeEditorComponentsPreloader)();
    }
    componentWillUnmount() {
        if (this.props.open) this._close();
        (0, $3IK76.unbind)('remove.dialog', this._afterDialogClosed);
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.isOpening = false;
        this.forceReloadInNextOpen = true;
        this._setOpenState = (openState)=>{
            if (openState) this._open();
            else this._close();
        };
        /**
     * Close the create dialog
     * @private
     */ this._close = ()=>{
            // Destroy the dialog
            if (typeof this._confluenceDialogClose === 'function') {
                // a defensive way to make sure legacy code should not break our React code due to unknown error.
                try {
                    this._confluenceDialogClose();
                } catch (error) {
                    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                        attribution: (0, $3IBnw.Attribution).PAGE_MODES
                    });
                }
                this._confluenceDialogClose = null;
            }
        };
        /**
     * Triggered after dialog closed
     * @private
     */ this._afterDialogClosed = (e, { dialog: dialog })=>{
            if (dialog.id === 'create-dialog') {
                this._confluenceDialogClose = null;
                this._close(e);
                this.props.onClose();
            }
        };
        this._isActive = ()=>!!(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector('#create-dialog');
        this._open = ()=>{
            if (!this._isActive() && !this.isOpening) {
                this.isOpening = true;
                (0, $cpjd2.requireLegacyWRM)([
                    'wrc!com.atlassian.confluence.plugins.confluence-create-content-plugin:resources',
                    'wrc!com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-resources',
                    'wrc!com.atlassian.plugins.atlassian-connect-plugin:blueprint-css-resources',
                    'wrc!com.atlassian.plugins.atlassian-connect-plugin:icons-css-resources',
                    'wrc!com.atlassian.plugins.atlassian-connect-plugin:dynamic-css-resources'
                ], ()=>{
                    // Although we've included 'wr!com.atlassian.plugins.atlassian-connect-plugin:dynamic-css-resources' here
                    // The 'link-style-css' may have been executed somewhere else previously.
                    // Requiring it again will not have effect. Here we are going to manually initialize it.
                    (0, $lolFL.default)({
                        listener: 'PseudoCreateDialog',
                        module: 'ac/confluence/style/link-style-css'
                    }, ()=>{
                        const linkStyleCSS = (0, $fU6PL.globalRequire)('ac/confluence/style/link-style-css');
                        if (linkStyleCSS && typeof linkStyleCSS.addLinkTags === 'function') linkStyleCSS.addLinkTags();
                    });
                    const { shouldSuppressDialog: shouldSuppressDialog, spaTransitionEnabled: spaTransitionEnabled } = this.props;
                    if (!shouldSuppressDialog) (0, $cSdzn.default)({
                        listener: 'PseudoCreateDialog',
                        globalProperty: 'Confluence.Blueprint.loadDialog'
                    }, ()=>{
                        const { parentPageId: parentPageId, parentPageTitle: parentPageTitle, parentPageType: parentPageType, parentPageSpaceKey: parentPageSpaceKey } = this.props;
                        (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).Confluence.Blueprint.loadDialog({
                            triggerSrc: 'create-page',
                            forceReload: this.forceReloadInNextOpen,
                            parentPageId: parentPageId,
                            parentPageTitle: parentPageTitle,
                            parentPageType: parentPageType,
                            parentPageSpaceKey: parentPageSpaceKey,
                            spaTransitionEnabled: spaTransitionEnabled
                        }).then((dialog)=>{
                            this.isOpening = false;
                            this.forceReloadInNextOpen = false;
                            this._confluenceDialogClose = dialog.closeDialog;
                            (0, $fGzMp.getExperienceTracker)().succeed({
                                name: (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE)
                            });
                        });
                    });
                }, ()=>{});
            }
        };
    }
}
$b12964423d7a55a9$export$96127edb89d86a28.displayName = 'PseudoCreateDialog';
$b12964423d7a55a9$export$96127edb89d86a28.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    shouldSuppressDialog: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    //The ID of the parent page under which to create a page. Leave blank for
    //current page.
    parentPageId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    parentPageTitle: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    parentPageType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    parentPageSpaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    spaTransitionEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$b12964423d7a55a9$export$96127edb89d86a28.defaultProps = {
    onClose: ()=>{}
};



var $dw6y2 = parcelRequire("dw6y2");

const $e3be5a849a5a9c6f$export$660930d210f51579 = (push)=>({ url: url, data: data, requestData: requestData })=>{
        // NOTE: the editor version is currently available for blank page and blog posts,
        // but not yet available for templates/blueprints. So for templates and blueprints
        // the full page transition.
        const isFabric = requestData?.metadata?.properties?.editor?.value === 'v2';
        const draftUrl = requestData.type === 'blogpost' ? (0, $dw6y2.createEditDraftBlogUrl)(data) : (0, $dw6y2.createEditDraftPageUrl)(data);
        if (isFabric && draftUrl) push(draftUrl);
        else // In case of any error or for non-fabric pages just fallback to the default
        // behavior - to the full page redirect navigation.
        window.location = url;
    };


/**
 * Wrapper for PseudoCreateDialog. We can query for the (likely) cached page
 * title, and pass it to the dialog. The dialog displays what the parent page
 * will be to the user.
 */ const $9a236338be49baca$export$569e9ae830934ef5 = (props)=>{
    const logger = (0, $7W8i8.getLogger)('PseudoCreateDialog');
    const { parentPageId: parentPageId } = props;
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isNotContextual = !parentPageId;
    const { data: data, error: error, loading: loading } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query PseudoCreateDialogQuery($parentPageId:ID!){content(id:$parentPageId){nodes{id title type space{id key}}}}`, {
        variables: {
            parentPageId: parentPageId
        },
        skip: isNotContextual
    });
    (0, $42omo.useEffect)(()=>{
        (0, $joCMa.getLegacyMessageQueue)().then((legacyMessageQueue)=>{
            legacyMessageQueue.push({
                type: 'ATLASSIAN_CONFLUENCE_CREATE_PAGE_NAVIGATE_CALLBACK',
                payload: (0, $e3be5a849a5a9c6f$export$660930d210f51579)(push)
            });
        });
    }, [
        push
    ]);
    if (isNotContextual) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b12964423d7a55a9$export$96127edb89d86a28), {
        spaTransitionEnabled: true,
        spaceKey: spaceKey,
        ...props
    });
    if (loading) return null;
    if (error) {
        logger.error`${error}`;
        return null;
    }
    const parentPageType = data?.content?.nodes?.[0]?.type;
    const parentPageTitle = data?.content?.nodes?.[0]?.title;
    const parentPageSpaceKey = data?.content?.nodes?.[0]?.space?.key;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b12964423d7a55a9$export$96127edb89d86a28), {
        spaTransitionEnabled: true,
        parentPageTitle: parentPageTitle,
        parentPageType: parentPageType,
        parentPageSpaceKey: parentPageSpaceKey,
        spaceKey: spaceKey,
        ...props
    });
};
$9a236338be49baca$export$569e9ae830934ef5.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    shouldSuppressDialog: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    //The ID of the parent page under which to create a page. Leave blank for
    //current page.
    parentPageId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
module.exports["PseudoCreateDialog"] = $9a236338be49baca$export$569e9ae830934ef5;

});


//# sourceMappingURL=CreateDialogQueryRenderer.9bd653db.js.map
